import React, { useState, lazy } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
type Product = {
  title: string;
  url: string;
};
const PLACEHOLDER_IMAGE = 'https://cdn.magicpatterns.com/uploads/5s4q5Jeo1QtC84S1wuuJih/product-placeholder.png';
const allProducts: Product[] = [{
  title: 'GNLD Pro Vitality',
  url: 'https://www.bestvitaminsforall.com/m8/3140S--gnld-neolife-pro-vitality-plus-pack.html'
}, {
  title: 'GNLD Salmon Oil Plus',
  url: 'https://www.bestvitaminsforall.com/m8/3502S--neolife-omega-3-salmon-oil-plus.html'
}, {
  title: 'GNLD Tre En En',
  url: 'https://www.bestvitaminsforall.com/m8/3130S--gnld-neolife-tre-en-en.html'
}, {
  title: 'GNLD Lipotropic Adjunct',
  url: 'https://www.bestvitaminsforall.com/m8/3510S--gnld-neolife-lipotropic-adjunct.html'
}, {
  title: 'GNLD Phytodefense',
  url: 'https://www.bestvitaminsforall.com/m8/3309S--gnld-neolife-phytodefense.html'
}, {
  title: 'GNLD Vitamin E',
  url: 'https://www.bestvitaminsforall.com/m8/3340S--gnld-neolife-vitamin-e-plus-water-miscible.html'
}, {
  title: 'GNLD Tre',
  url: 'https://www.bestvitaminsforall.com/m8/3010S--gnld-neolife-tr-tre.html'
}, {
  title: 'GNLD Carotenoid Complex',
  url: 'https://www.bestvitaminsforall.com/m8/3300S--gnld-neolife-daily-carotenoid-complex.html'
}, {
  title: 'GNLD Active 40 Plus',
  url: 'https://www.bestvitaminsforall.com/m8/3115S.html'
}, {
  title: 'GNLD Cal Mag',
  url: 'https://www.bestvitaminsforall.com/m8/3402S--chelated-cal-mag-with-vitamin-d-capsules.html'
}, {
  title: 'GNLD Masculine Herbal Complex',
  url: 'https://www.bestvitaminsforall.com/m8/3625S--masculine-herbal-complex.html'
}, {
  title: 'GNLD Feminine Herbal Complex',
  url: 'https://www.bestvitaminsforall.com/m8/3615S--feminine-herbal-complex.html'
}, {
  title: 'GNLD Formula IV Plus',
  url: 'https://www.bestvitaminsforall.com/m8/3105S--gnld-neolife-formula-iv-plus.html'
}, {
  title: 'GNLD Garlic Allium',
  url: 'https://www.bestvitaminsforall.com/m8/3665S--garlic-allium-complex.html'
}, {
  title: 'GNLD Full Motion',
  url: 'https://www.bestvitaminsforall.com/m8/3505S--neolife-glucosamine-full-motion.html'
}, {
  title: 'GNLD Enzyme Digestive Aid',
  url: 'https://www.bestvitaminsforall.com/m8/3520S--enzyme-digestive-aid.html'
}, {
  title: 'GNLD Betagard',
  url: 'https://www.bestvitaminsforall.com/m8/3530S--gnld-neolife-betagard.html'
}, {
  title: 'GNLD Aloe Vera Plus Juice',
  url: 'https://www.bestvitaminsforall.com/m8/3000S--aloe-vera-plus-best-aloe-vera-juice.html'
}, {
  title: 'GNLD All C Vitamin C',
  url: 'https://www.bestvitaminsforall.com/m8/3332S--all-c-chewable-250-tablets-vitamin-c.html'
}, {
  title: 'GNLD Stress 30',
  url: 'https://www.bestvitaminsforall.com/m8/3113S.html'
}, {
  title: 'GNLD Zinc',
  url: 'https://www.bestvitaminsforall.com/m8/3425S--chelated-zinc.html'
}, {
  title: 'Multipure CB5 Filters',
  url: 'https://www.bestvitaminsforall.com/m8/34S%28cl%29--multipure-cb5-water-filter-under-counter-counter-top-also-fits-gnld-neolife-filter-system-only-a-few-left.html'
}, {
  title: 'GNLD Distributors',
  url: 'https://www.bestvitaminsforall.com/21.html'
}];
const ITEMS_PER_PAGE = 12;
export function AllProducts() {
  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = 6; // Hardcoded to show 6 pages for 71 products
  const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
  const currentProducts = allProducts.slice(startIndex, startIndex + ITEMS_PER_PAGE);
  return <section className="bg-white py-12 lg:py-16 border-t border-gray-100" data-id="element-29">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-30">
        <div className="flex items-center gap-4 mb-8" data-id="element-31">
          <h2 className="text-xl lg:text-2xl font-bold text-gray-900" data-id="element-32">
            All Products
          </h2>
          <div className="h-0.5 bg-[#0e7be1] flex-grow max-w-[80px]" data-id="element-33"></div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 lg:gap-4 mb-10" data-id="element-34">
          {currentProducts.map((product, index) => <a key={`${product.title}-${index}-all`} href={product.url} className="block bg-white border border-gray-100 rounded-lg overflow-hidden" data-id="element-35">
              <div className="aspect-square w-full bg-gray-50 p-3" data-id="element-36">
                <img src={PLACEHOLDER_IMAGE} alt={product.title} className="w-full h-full object-contain" loading="lazy" data-id="element-37" />
              </div>
              <div className="p-3" data-id="element-38">
                <h3 className="text-xs lg:text-sm font-medium text-gray-800 line-clamp-2 leading-snug" data-id="element-39">
                  {product.title}
                </h3>
              </div>
            </a>)}
        </div>

        {/* Pagination */}
        <div className="flex justify-center items-center gap-1" data-id="element-40">
          <button onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))} disabled={currentPage === 1} className="p-2 rounded border border-gray-200 text-gray-500 hover:bg-gray-50 disabled:opacity-40 disabled:cursor-not-allowed" aria-label="Previous page" data-id="element-41">
            <ChevronLeft className="h-4 w-4" data-id="element-42" />
          </button>

          {[...Array(totalPages)].map((_, i) => <button key={i} onClick={() => setCurrentPage(i + 1)} className={`w-9 h-9 rounded text-sm font-medium transition-colors ${currentPage === i + 1 ? 'bg-[#0e7be1] text-white' : 'border border-gray-200 text-gray-600 hover:bg-gray-50'}`} data-id="element-43">
              {i + 1}
            </button>)}

          <button onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))} disabled={currentPage === totalPages} className="p-2 rounded border border-gray-200 text-gray-500 hover:bg-gray-50 disabled:opacity-40 disabled:cursor-not-allowed" aria-label="Next page" data-id="element-44">
            <ChevronRight className="h-4 w-4" data-id="element-45" />
          </button>
        </div>
      </div>
    </section>;
}